import Image from 'next/image'

import styles from './styles.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark, faEye, faHeart, faShare, faXmark } from '@fortawesome/free-solid-svg-icons'

import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner'

import { useSocket } from '../../../Context/socket'
import { useSession } from 'next-auth/react'
import axios from 'axios'
import { PuffLoader, PulseLoader } from 'react-spinners'
import errorMsg from '../../../Functions/errorMsg'
import successMsg from '../../../Functions/successMsg'
import BusinessListing from '../BusinessListing/BusinessListing'

export default function LikedBusinesses({ setPendingRequest }) {

  const { socket } = useSocket();
  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [likedListings, setLikedListings] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(likedListings !== null) return;
    if(status === 'loading') return;
    if(!session) return;

    async function getLikedBusinesses() {
        setInitialLoading(true);
        setPendingRequest(true);

        const result = await axios.post(`${window.location.origin}/api/business/dashboard/getLikedBusinesses`, {
          requestingUserID: session.user.token.id
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
        })

        if(result && result.status === 200) {
          const data = result.data;
          setLikedListings(data);
        }

        setPendingRequest(false);
    }

    getLikedBusinesses();

  }, [session, status])

  function isLoading() {
    if(status === 'loading') return true;
    if(initialLoading === false || initialLoading === null) return true;
    if(likedListings === null) return true;
    return false;
  }

  function handleLiked(type, listingID, username) {
    if(type === 'remove') {
      const listingPos = likedListings.findIndex((listing) => listing._id === listingID);
      if(listingPos > -1) {
        const updateLikeList = [...likedListings];
        updateLikeList[listingPos].likes.filter((user) => user !== username);
        setLikedListings(updateLikeList);

      } else {
        errorMsg("Oops! We could not remove this listing, try refreshing the page.");
      }
    }
    if(type === 'add') {
      const listingPos = likedListings.findIndex((listing) => listing._id === listingID);
      if(listingPos > -1) {
        const updateLikeList = [...likedListings];
        updateLikeList[listingPos].likes.push(username);
        setLikedListings(updateLikeList);

      } else {
        errorMsg("Oops! We could not remove this listing, try refreshing the page.");
      }
    }
  }

  const [viewListingData, setViewListingData] = useState(null); // ListingID Stored

  return (
    <section id={styles.wrapper}>
      { viewListingData !== null && <BusinessListing listingID={viewListingData} closeListing={() => setViewListingData(null)} /> }

      { isLoading() === true && <section id={styles.loading}><PulseLoader size={30} color='#154734' /></section> }

      { isLoading() === false && (likedListings.length === 0 ?
        <div id={styles.noListings}>
          <h1>You have liked no businesses</h1>
        </div>
        :
        <section id={styles.container}>
          {
            likedListings.map((listing, index) => {
              return <ListingCard key={index} session={session} listing={listing} setViewListingData={setViewListingData} handleLiked={handleLiked} />
            })
          }
        </section>
      )}

  </section>
  )
}

const ListingCard = ({ session, listing, setViewListingData, handleLiked }) => {

  const listingID = listing._id;

  const [coverLoaded, setCoverLoaded] = useState(false);
  const getCover = listing.images.findIndex((images) => images.position === 1);

  const username = session.user.token.username;

  const [liked, setLiked] = useState(listing?.likes?.some(liker => username === liker));
  const [likePending, setLikePending] = useState(false);

  async function apiHandleLike() {
      if(likePending === true) return;
      setLikePending(true);

      const username = session.user.token.username;
      const listingID = listing._id;

      if(liked === false) {
        const result = await axios.post(`${window.location.origin}/api/business/helpers/like`, {
            listingID: listingID,
            username: username,
        }).catch((error) => {
          errorMsg(error?.response?.data?.status || error.toString());
        })

        if(result && result.status === 200) {
          handleLiked('add', listingID, username)
          setLiked(true);
          successMsg("Business added to my likes.");
        }
        
      }

      if(liked === true) {
        const result = await axios.post(`${window.location.origin}/api/business/helpers/unlike`, {
            listingID: listingID,
            username: username,
        }).catch((error) => {
          errorMsg(error?.response?.data?.status || error.toString());
        })
    
        if(result && result.status === 200) {
          handleLiked('remove', listingID, username)
          setLiked(false);
          successMsg("Business removed from my likes.");
        }
      }

      setLikePending(false)
  }

  return (
    <div className={styles.card}>
     <section>
        <h1>Data Area 1</h1>
        <div style={{display: coverLoaded === false ? 'flex' : 'none'}}> <LoadingSpinner type="pulse" color="#154734" /></div>
        <Image sizes='auto auto' fill src={listing.images[getCover].url} alt={listing.images[getCover].url} onLoadingComplete={() => setCoverLoaded(true)} />
      </section>
      <section>
        <div>
          <h1>
            Data Area 2
          </h1>
        </div>

        <div>
        <motion.button onClick={() => setViewListingData(listingID)}><FontAwesomeIcon icon={faEye} id={styles.icon} /></motion.button>

        <motion.button onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/?popup=sharedPost&_id=${listing._id}`); successMsg("Link Copied") } }><FontAwesomeIcon icon={faShare} id={styles.icon} /></motion.button>

        <motion.button onClick={() => apiHandleLike()}>
          { likePending === false && <>
            <FontAwesomeIcon style={{marginRight: liked === true ? '8px' : '0px'}} icon={faHeart} id={styles.icon} color='white'  />
            { liked === true && <FontAwesomeIcon icon={faXmark} id={styles.icon2} color='white' /> }
          </> }
          { likePending === true && <PuffLoader size={25} color='white' /> }
        </motion.button>
        </div>

      </section>
    </div>
  )
}